import gql from "graphql-tag";
import { Query } from "react-apollo";
import { HomeAssets, HomeRoutes } from "../../components/home/Index";
import { Area, AssetOutput, AssetVariable, RentalAdvert, RouteInput, RouteOutput, RouteVariable, Theme, User } from "../../types/types";
import { Connection } from "../graphql";
import * as RouteHelpers from "../routes";



type QueryVariables = {
  routes: Array<RouteVariable<HomeRoutes>>
  assets: Array<AssetVariable<HomeAssets>>
  set: 'highlights'
  areaset: 'highlights'
}

export type QueryResult = {
  routes: Array<RouteOutput<HomeRoutes>>
  siteSettings: {
    homepageImage: {
      url: string
    }
    contentAboveCarousel: string
  }
  assets: Array<AssetOutput<HomeAssets>>
  highlighted_adverts: Connection<RentalAdvert>
  highlighted_areas: Connection<Area>
  highlighted_themes: Connection<Theme>
}

export class HomeQuery extends Query<QueryResult, QueryVariables> {}

export const query = () => {
  return gql`
    query Home($areaset: AreaSet!, $set: RentalAdvertSet!, $routes: [RouteInput!]!, $assets: [AssetInput!]!) {
      highlighted_themes: themes(onlyFeatured:true, first:2) {
        edges {
          node {
            id
            name
            identifier
            featuredTitle
            readMoreText
            bodySnippet
            bodyContent
            path
            illustration {
              url
            }
          }
          cursor
        }
      }
      routes: routes(routes: $routes) {
        url
        path
        name
        identifier
      }
      highlighted_adverts: rentalAdvertSet(set: $set, first:3) {
        edges {
          node {
            id
            objectName
            path
            overviewImage {
              url(crop: "index_thumb")
            }
            city {
              name
            }
          }
          cursor
        }
      }
      highlighted_areas: areaSet(set: $areaset, first:6) {
        edges {
          node {
            id
            name
            path
            headerImage {
              url(crop:"highlight")
            }
            rentalAdvertCount
          }
          cursor
        }
      }
      siteSettings{
        homepageImage {
          url(crop: "high")
        }
        contentAboveCarousel
      }
      assets(assets: $assets) {
        identifier
        url
      }
    }
  `
}

const RoutesVariables = (): RouteVariable<HomeRoutes>[] =>
  RouteHelpers.ToGraphqlVariable<HomeRoutes>({
    lastminutes: { name: 'boolean_gites', args: { booleans: ['last_minute'] } },
    corona_policy: {
      name: 'boolean_gites',
      args: { booleans: ['corona_policy'] }
    },
    gites: { name: 'boolean_gites' },
    areas: { name: 'areas' },
    themes: { name: 'themes' }
  })

export const variables = (): QueryVariables => {
  return {
    routes: RoutesVariables(),
    assets: [
      {
        identifier: 'gites-zoover-award-2019.png'
      },
      {
        identifier: "home/last-minutes-sticker.svg"
      }
    ],
    set: 'highlights',
    areaset: 'highlights'
  }
}
